import Dropzone from 'dropzone'

export default (): void => {
  window.onDomLoad(($dom) => {
    const dropzones = $dom[0].querySelectorAll(
      "[data-behaviour~='adjustment-import-dropzone']"
    )

    dropzones.forEach((dropzone) => {
      const effectiveElement = dropzone as HTMLElement

      new Dropzone(effectiveElement, {
        paramName: 'adjustment_import[as_csv]',
        createImageThumbnails: false,
        maxFiles: 1,
        acceptedFiles: '.csv,.xlsx,.xls,.ods',
        clickable: '.browse-files',
        url: effectiveElement.dataset.url,
        dictDefaultMessage: '',
        dictInvalidFileType: '',
        dictMaxFilesExceeded: '',
        init(): void {
          this.on(
            'success',
            (file, response: { ledger_id: number; id: number }) => {
              const path =
                window.Silverfin.Routes.ledger_adjustment_import_path(
                  window.Silverfin.currentFirmId,
                  window.Silverfin.currentCompanyId,
                  response.ledger_id,
                  response.id
                )

              window.Turbolinks.visit(path)
            }
          )
        },
      })
    })
  })
}
